import {
	getTapTraitsForSiteUser,
	type GetTapTraitsForSiteUserInput,
} from '@post-office/util-tap-traits';

export const TEMPLATE_XFLOW_REMINDER_TRAIT_KEY = 'twc_xflow_conf_meeting_pages_templates_reminder';
export const TEMPLATE_XFLOW_REMINDER_TRAIT_VALUE = 'remind';
export const TEMPLATE_XFLOW_DISMISSED_TRAIT_VALUE = 'dismissed';

export type TemplateXflowReminderTapTraitValue =
	| typeof TEMPLATE_XFLOW_REMINDER_TRAIT_VALUE
	| typeof TEMPLATE_XFLOW_DISMISSED_TRAIT_VALUE;

export type TemplateXflowReminderTapTraitState =
	| TemplateXflowReminderTapTraitValue
	| 'absent'
	| 'unexpected';

export type TemplateXflowReminderTapTraitContext = {
	tapReminderTrait?: TemplateXflowReminderTapTraitValue;
	tapReminderTraitState: TemplateXflowReminderTapTraitState;
};

export const getTemplateXflowReminderTapTrait = async (
	input: GetTapTraitsForSiteUserInput,
): Promise<TemplateXflowReminderTapTraitContext> => {
	const traits = await getTapTraitsForSiteUser(input);
	const reminder = traits?.[TEMPLATE_XFLOW_REMINDER_TRAIT_KEY];

	if (
		reminder === TEMPLATE_XFLOW_REMINDER_TRAIT_VALUE ||
		reminder === TEMPLATE_XFLOW_DISMISSED_TRAIT_VALUE
	) {
		return { tapReminderTrait: reminder, tapReminderTraitState: reminder };
	}

	return {
		tapReminderTrait: undefined,
		tapReminderTraitState: reminder === undefined ? 'absent' : 'unexpected',
	};
};
